/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {View} from 'react-native';
import SubmitButtons from '../../components/Button/SecondaryButton';
import {formsStyles} from '../../components/Inputs/formStyles';
import {InputField} from '../../components/Inputs/InputField';
import {InputAutocompletion} from '../../components/Inputs/InputAutocompletion';
import { useForm } from '../../../hooks/DemanderRDV/useForm';
import { Validation } from '../../../common/utils/validationDemanderRDV';
import { titleLabels } from '../../../data/constants/demanderRDV';

export const Form = (props: any) => {
  const {data, listAgence, onCancelForm, onSubmitForm, prime} = props;

  const {handleChange, handleSubmit, values, errors, showErrors, dto} = useForm(
    data,
    Validation,
    handleCancel,
    handleSave,
    listAgence,
    prime,
  );

  const userConnected = data.mail !== '';

  function handleCancel() {
    onCancelForm();
  }

  function handleSave() {
    onSubmitForm(dto.data);
  }

  return (
    <View style={formsStyles.containerLayout}>
      {/** form inputs */}
      <View>
        <InputField
          label={titleLabels.contractant.nomPrenom}
          required
          value={values.nomPrenom}
          name="nomPrenom"
          onChange={handleChange}
          error={errors.nomPrenom}
          showError={showErrors.nomPrenom}
          maxLength={70}
          isEditable={!userConnected}
        />
        <InputField
          label={titleLabels.contractant.telephone}
          required
          name="telephone"
          type="telephone"
          value={values.telephone}
          onChange={handleChange}
          error={errors.telephone}
          showError={showErrors.telephone}
          isEditable={!userConnected}
        />
        <InputField
          label={titleLabels.contractant.mail}
          required
          name="mail"
          value={values.mail}
          onChange={handleChange}
          error={errors.mail}
          showError={showErrors.mail}
          isEditable={!userConnected}
        />

        <InputAutocompletion
          label={titleLabels.contractant.agence}
          required
          data={listAgence}
          name="agence"
          value={values.agence}
          onChange={handleChange}
          error={errors.agence}
          showError={showErrors.agence}
        />
        <InputField
          label={titleLabels.contractant.objet}
          required
          value={values.objet}
          name="objet"
          onChange={handleChange}
          error={errors.objet}
          showError={showErrors.objet}
          maxLength={70}
        />
        <InputField
          label={titleLabels.contractant.message}
          required
          type="textArea"
          value={values.message}
          name="message"
          onChange={handleChange}
          error={errors.message}
          showError={showErrors.message}
          maxLength={1000}
        />
      </View>
      {/** Submit buttons */}
      <View style={formsStyles.containerBtn}>
        <SubmitButtons
          cancelAction={handleCancel}
          submitAction={handleSubmit}
          cancelTitle="Annuler"
          submitTitle="Envoyer la demande"
        />
      </View>
    </View>
  );
};
